import { render, staticRenderFns } from "./VideoCallsFormDialog.vue?vue&type=template&id=487e40d8&"
import script from "./VideoCallsFormDialog.vue?vue&type=script&lang=js&"
export * from "./VideoCallsFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports